import { AllowedPlatform, AllowedPlatformsRule, Rule } from '../types/Rules';

export type Channel = AllowedPlatform | 'offline';

export const CHANNELS: Channel[] = ['web', 'mobile_pax', 'offline'];

export const CHANNEL_LABELS: Record<Channel, string> = {
  web: 'Web',
  mobile_pax: 'App',
  offline: 'Offline (agencies)',
};

const PLATFORMS: AllowedPlatform[] = ['web', 'mobile_pax'];

// offline_sales = agencies only, no_agency_sales = agencies excluded,
// allowed_platforms = strict web/app subset (absent means both).
export const getChannelsFromRules = (rules: Rule[] = []): Channel[] => {
  if (rules.some(r => r.type === 'offline_sales')) return ['offline'];

  const allowedRule = rules.find((r): r is AllowedPlatformsRule => r.type === 'allowed_platforms');
  const platforms = allowedRule?.platforms.length
    ? PLATFORMS.filter(p => allowedRule.platforms.includes(p))
    : PLATFORMS;
  const agenciesExcluded = rules.some(r => r.type === 'no_agency_sales');

  return [...platforms, ...(agenciesExcluded ? [] : (['offline'] as Channel[]))];
};

export const getRulesForChannels = (channels: Iterable<Channel>) => {
  const selected = new Set(channels);
  const platforms = PLATFORMS.filter(p => selected.has(p));
  const offline = selected.has('offline');

  return {
    allowedPlatforms: platforms.length === PLATFORMS.length ? [] : platforms,
    offlineSales: offline && platforms.length === 0,
    noAgencySales: !offline && platforms.length > 0,
  };
};

export const formatChannels = (rules?: Rule[]) =>
  getChannelsFromRules(rules)
    .map(c => CHANNEL_LABELS[c])
    .join(', ');
